import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type {
  PortalContentKey,
  PortalContentResolution,
} from "@colab/shared";

// GET /api/portal/portal-content — full resolution map of every
// PortalContentKey, narrowed to the viewing partner's tier + partner_type.
// The dashboard uses .welcome (banner copy + CTA) and .level_up (badge ladder
// content); /portal/support uses .support_links (sub-bucket 8).
export type PortalContentMap = {
  [K in PortalContentKey]: PortalContentResolution<K>;
};

export function usePortalContent() {
  return useQuery<PortalContentMap, ApiClientError>({
    queryKey: queryKeys.portal.content(),
    queryFn: () => apiFetch<PortalContentMap>("/portal/portal-content"),
  });
}
